import PouchDB from "pouchdb-browser";
import PouchDbFind from "pouchdb-find";

PouchDB.plugin(PouchDbFind);
const database = new PouchDB("applebridge-db");

export default database;
